import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, TextAlpha } from '@yonderland/andes-react';
export const CheckoutConfirmationSupportInfo = ({ support, }) => (_jsxs(TextAlpha, { children: [support.info, " ", _jsx(Link, { href: support.href, children: support.linkLabel })] }));
